import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './utils/element'
import './styles/globasl.styl'
import * as filters from './filters' // global filters
// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
import Moment from 'moment'
Vue.prototype.$moment = Moment
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
